import { MenuControllerId, MenuItem } from '@adaptiva/core/menus';
import { EJavaClassNames, SensorServerObject, ServerObjectMultiMenuController } from '@adaptiva/data-service';
import { EServerOverlayIds } from '@adaptiva/server/overlays';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

@Injectable()
export class SensorMultiMenuController<T extends SensorServerObject> extends ServerObjectMultiMenuController<T> {

	public static override readonly id: MenuControllerId.Any = `${MenuControllerId.Prefix.Multi}${EJavaClassNames.SensorServerObject}`;

	public readonly resetSensorMenuName: string = 'Reset Sensors';

	public override generate(_sensor: T[]): Observable<MenuItem<T[]>[]> {
		return super.generate(_sensor).pipe(
			map((_items: MenuItem<T[]>[]) => {
				return _items.concat(
					this.getResetSensorsMenuItem(_sensor),
				);
			})
		);
	}

	public override getClassName(): string {
		return EJavaClassNames.SensorServerObject;
	}

	protected getResetSensorsMenuItem(_sensor: T[]): MenuItem<T[]> {
		const _item: MenuItem<T[]> = this.getItem(this.resetSensorMenuName, null) || this.createItem({
			id: this.resetSensorMenuName,
			name: this.resetSensorMenuName,
			data: _sensor,
			onSelect: this.resetSensors.bind(this)
		});

		this.enableResetSensors(_item);

		return _item;
	}

	protected enableResetSensors(_item: MenuItem<T[]>): void {
		_item.isDisabled.next(this.selectionManager.isEmpty());
	}

	protected resetSensors(_item: MenuItem<T[]>): void {
		this.overlays.load({
			overlayId: EServerOverlayIds.SENSOR_RESET_OVERLAY,
			context: { sensorIds: this.selectionManager.toArray().map(g => g.objectId) }
		}).pipe(
			this.takeOneUntilDestroyed(),
		).subscribe({
			error: (e: Error): void => {
				this.errorHandler.defaultErrorHandler(e, 'SensorMultiMenuController.resetSensors');
			}
		});
	}

}
